import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["width", "height", "opacity"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M18 23C18 20.7909 19.7909 19 22 19H37C39.2091 19 41 20.7909 41 23V41H18V23Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M38 21H23C21.8954 21 21 21.8954 21 23V39H40V23C40 21.8954 39.1046 21 38 21ZM23 19C20.7909 19 19 20.7909 19 23V41H42V23C42 20.7909 40.2091 19 38 19H23Z\" fill=\"#4D4E58\"></path><rect x=\"24\" y=\"25\" width=\"13\" height=\"3\" fill=\"#4D4E58\"></rect><rect x=\"24\" y=\"31\" width=\"13\" height=\"3\" fill=\"#4D4E58\"></rect><path d=\"M6 11.8824C6 9.73819 7.79086 8 10 8H25C27.2091 8 29 9.73819 29 11.8824V41H6V11.8824Z\" fill=\"white\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M25 9.94118H10C8.89543 9.94118 8 10.8103 8 11.8824V39.0588H27V11.8824C27 10.8103 26.1046 9.94118 25 9.94118ZM10 8C7.79086 8 6 9.73819 6 11.8824V41H29V11.8824C29 9.73819 27.2091 8 25 8H10Z\" fill=\"#4D4E58\"></path><path d=\"M22 39L8 12V39H22Z\" fill=\"#E0E5FF\"></path><path d=\"M15 35C15 34.4477 15.4477 34 16 34H19C19.5523 34 20 34.4477 20 35V40H15V35Z\" fill=\"#4D4E58\" stroke=\"#4D4E58\" stroke-width=\"2\"></path><rect x=\"11\" y=\"13\" width=\"13\" height=\"3\" fill=\"#4D4E58\"></rect><rect x=\"11\" y=\"19\" width=\"13\" height=\"3\" fill=\"#4D4E58\"></rect><rect x=\"11\" y=\"25\" width=\"13\" height=\"3\" fill=\"#4D4E58\"></rect>", 11)
const _hoisted_13 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  name: 'CompanyIcon',
  props: {
    size: null,
    opacity: null
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size || 48,
    height: __props.size || 48,
    viewBox: "0 0 48 48",
    opacity: __props.opacity || 1,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_13, 8, _hoisted_1))
}
}

})